var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from 'events';
// Defined list of error Objects for JiveCall
var TRANSFER_SUCCESS = {
    errorCode: 'TRANSFER_SUCCESS',
    message: 'Call transfer completed'
};
var CALL_HANGUP = {
    errorCode: 'CALL_HANGUP',
    message: 'Call hanged up'
};
var CALL_CANCELLED = {
    errorCode: 'CALL_CANCELLED',
    message: 'Incoming call was cancelled before it could be answered'
};
var CALL_COMPLETED_ELSEWHERE = {
    errorCode: 'CALL_COMPLETED_ELSEWHERE',
    message: 'Incoming call was answered elsewhere'
};
var DEVICE_OUTPUT_FAILED = {
    errorCode: 'DEVICE_OUTPUT_FAILED',
    message: 'Output device selection failed'
};
var DEVICE_OUTPUT_NOT_SUPPORTED = {
    errorCode: 'DEVICE_OUTPUT_NOT_SUPPORTED',
    message: 'Browser does not support output device selection'
};
var DEVICE_OUTPUT_SECURITY = {
    errorCode: 'DEVICE_OUTPUT_SECURITY',
    message: 'HTTPS required for selecting audio output device'
};
var AUDIO_ELEMENT_INVALID = {
    errorCode: 'AUDIO_ELEMENT_INVALID',
    message: 'Audio element parameter invalid'
};
var CALL_UNINITIALIZED = {
    errorCode: 'CALL_UNINITIALIZED',
    message: 'The current operation requires the call to be initialised'
};
var PEER_CONNECTION_UNINITIALIZED = {
    errorCode: 'PEER_CONNECTION_UNINITIALIZED',
    message: 'The current operation requires the peer connection to be initialised'
};
var MIXING_AUDIO_STREAM_NOT_SUPPORTED = {
    errorCode: 'MIXING_AUDIO_STREAM_NOT_SUPPORTED',
    message: 'Mixing non-audio streams is currently unsupported'
};
var MEDIA_MIXING_ERROR = {
    errorCode: 'MEDIA_MIXING_ERROR',
    message: 'Error while mixing streams.'
};
var CallEvents = /** @class */ (function (_super) {
    __extends(CallEvents, _super);
    function CallEvents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * The call is connected and call related events can be sent or received
         */
        _this.CONNECTED = 'CALL_CONNECTED';
        /**
         * The call is connecting and call related events can not be sent or received
         */
        _this.CONNECTING = 'CALL_CONNECTING';
        /**
         * The call is ringing at the remote side and call related events can be sent or received
         */
        _this.RINGING = 'CALL_RINGING';
        /**
         * The call is disconnected and no events can be sent or received
         */
        _this.DISCONNECTED = 'CALL_DISCONNECTED';
        /**
         * The call media track is received and can be attached to an audio or video element
         */
        _this.TRACK = 'CALL_TRACK';
        /**
         * The call rtp stream is not detected, the terminating side can not hear the media
         */
        _this.NO_MEDIA_RECEIVED = 'CALL_NO_MEDIA_RECEIVED';
        /**
         * The callee track is at talking levels
         */
        _this.CALLEE_TALKING = 'CALL_CALLEE_TALKING';
        /**
         * The callee track is below talking levels
         */
        _this.CALLEE_STOPPED_TALKING = 'CALL_CALLEE_STOPPED_TALKING';
        /**
         * The call media stats for a given media track is received and can be used for statistics monitoring
         */
        _this.STATS = 'CALL_STATS';
        /**
         * CALL_STREAM_QUALITY
         */
        _this.STREAM_QUALITY = 'CALL_STREAM_QUALITY';
        /**
         * CALL_UPDATED
         */
        _this.UPDATE = 'CALL_UPDATED';
        return _this;
    }
    Object.defineProperty(CallEvents.prototype, "TRANSFER_SUCCESS", {
        // Getter methods to defined errors for JiveCall
        get: function () {
            return TRANSFER_SUCCESS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "CALL_HANGUP", {
        get: function () {
            return CALL_HANGUP;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "CALL_CANCELLED", {
        get: function () {
            return CALL_CANCELLED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "CALL_COMPLETED_ELSEWHERE", {
        get: function () {
            return CALL_COMPLETED_ELSEWHERE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "DEVICE_OUTPUT_FAILED", {
        get: function () {
            return DEVICE_OUTPUT_FAILED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "DEVICE_OUTPUT_NOT_SUPPORTED", {
        get: function () {
            return DEVICE_OUTPUT_NOT_SUPPORTED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "DEVICE_OUTPUT_SECURITY", {
        get: function () {
            return DEVICE_OUTPUT_SECURITY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "AUDIO_ELEMENT_INVALID", {
        get: function () {
            return AUDIO_ELEMENT_INVALID;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "CALL_UNINITIALIZED", {
        get: function () {
            return CALL_UNINITIALIZED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "PEER_CONNECTION_UNINITIALIZED", {
        get: function () {
            return PEER_CONNECTION_UNINITIALIZED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "MIXING_AUDIO_STREAM_NOT_SUPPORTED", {
        get: function () {
            return MIXING_AUDIO_STREAM_NOT_SUPPORTED;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CallEvents.prototype, "MEDIA_MIXING_ERROR", {
        get: function () {
            return MEDIA_MIXING_ERROR;
        },
        enumerable: true,
        configurable: true
    });
    return CallEvents;
}(EventEmitter));
export default CallEvents;
//# sourceMappingURL=JiveCallEvents.js.map